import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { throwIfAlreadyLoaded } from '@app/shared/utils';
import { API_SERVICES } from '@app/api/api-services';

@NgModule()
export class ApiModule {
  constructor(@Optional() @SkipSelf() parentModule: NgModule) {
    throwIfAlreadyLoaded(parentModule, 'ApiModule');
  }
  public static forRoot(): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: API_SERVICES
    };
  }
}
